import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { IVoice } from '@d-id/types';

interface IOrganization {
    name: string;
    created_at: string;
    modified_at: string;
    id: string;
    owner_id: string;
    email: string;
}

export const featchOrg = async (orgId: string): Promise<IOrganization> => {
    const response = await authenticatedAxios.get(`${didApiUrl}/organizations/${orgId}`);
    return response?.data;
};

export const renameOrg = async (orgId: string, newName: string): Promise<IOrganization> => {
    const response = await authenticatedAxios?.put(`${didApiUrl}/organizations/${orgId}`, { name: newName });
    return response?.data;
};

export const updatePresenterOwner = async (presenterId: string, payload: { ownerId: string; newOwnerId: string }) => {
    const response = await authenticatedAxios.patch(`${didApiUrl}/clips/presenters/${presenterId}`, payload);
    return response?.data;
};

export const updatePresenterIdleVideo = async (presenterId: string, payload: { ownerId: string; idle_video: string }) => {
    const response = await authenticatedAxios.patch(`${didApiUrl}/clips/presenters/${presenterId}`, payload);
    return response?.data;
};

export const fetchOwnerVoices = async (ownerId: string): Promise<IVoice[]> => {
    const response = await authenticatedAxios.get(`${didApiUrl}/tts/owner-voices/${ownerId}`);
    return response?.data;
};

export const updateVoice = async (
    voiceId: string,
    payload: { name?: string; overrideOwnerId?: string; newOwnerId?: string }
): Promise<IVoice> => {
    const response = await authenticatedAxios.patch(`${didApiUrl}/tts/voices/${voiceId}`, payload);
    return response?.data;
};
